import Chart from './js/chart'
import Buttons from './js/buttons'

import './scss/main.scss'

import data from './data/poverty_data.json'

const typeSelector = '.interactive__filters--types'
let currentType

function init() {
  currentType = 'progress_percent'
  setupTypesSelector()

  drawChart()

  hideLoading()
}

/**
 *
 * An example of a button selector.
 *
 */

function setupTypesSelector() {
  const options = [
    { value: 'progress_percent', label: 'Poverty rate (%)' },
    {
      value: 'progress_absolute',
      label: 'number of people in poverty',
    },
  ]

  Buttons.createButtons({
    selector: typeSelector,
    data: options,
    current: currentType,
    onClick() {
      currentType = this.getAttribute('data-value')
      Buttons.setSelectedButton(currentType)
      drawChart()
    },
  })
}

/**
 *
 * Calls the Chart function to draw the chart with the current dataset.
 *
 */

function drawChart() {
  currentType = Buttons.getCurrent()
  let dataset = data.sort((a, b) => b[currentType] - a[currentType])

  Chart.init({
    data: dataset,
    container: '#interactive__charts',
  })
}

/**
 *
 * Hides all elements hidden on initial load
 *
 */

function hideLoading() {
  document.querySelector('.loading-container').style.display = 'none'
  document
    .querySelectorAll('.hide-on-load')
    .forEach((el) => el.classList.remove('hide-on-load'))
}

window.addEventListener('DOMContentLoaded', init)
